"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminIDBodyToJSON = exports.AdminIDBodyFromJSONTyped = exports.AdminIDBodyFromJSON = void 0;
function AdminIDBodyFromJSON(json) {
    return AdminIDBodyFromJSONTyped(json, false);
}
exports.AdminIDBodyFromJSON = AdminIDBodyFromJSON;
function AdminIDBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adminID': json['adminID'],
    };
}
exports.AdminIDBodyFromJSONTyped = AdminIDBodyFromJSONTyped;
function AdminIDBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adminID': value.adminID,
    };
}
exports.AdminIDBodyToJSON = AdminIDBodyToJSON;
